export enum PaymentType {
    razorpay = 1
}
